// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  IconButton,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Spinner,
  Stack,
  Switch,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import { MdOutlineSportsGymnastics } from "react-icons/md";
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import { utilConstants } from '../../utils/utilConstants';
import Utils from '../../utils/utils';

import {
  Link,
  useNavigate
} from "react-router-dom";


function UsersList() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [hidden, setHidden] = useState(false);
  const [premium, setPremium] = useState(false);
  const [idCategory, setIdCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [updatedChunks, setUpdatedChunks] = useState(0);
  const [totalChunks, setTotalChunks] = useState(0);
  const [allCategories, setAllCategories] = useState([]);
  const [search, setSearch] = useState("");
  const [defaultCat, setDefaultCat] = useState("-1");
  const [toplist, setToplist] = useState(false);
  const [coverPath, setCoverPath] = useState("")
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")
  const [startDate, setStartDate] = React.useState(null)
  const [currentUser, setCurrentUser] = React.useState({})
  const [isOpenPro, setIsOpenPro] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [isOpenTrainings, setIsOpenTrainings] = React.useState(false)
  const [users, setUsers] = React.useState([])
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    setUser(event.target.files[0]);
  };



  /* BEGIN - PRO */

  const changePro = async (type) => {
    setLoading(true)
    let userid = currentUser.id

    let resp = await postCall("/changeProAdmin", {
      user: currentUser,
      type: type
    })
    if (resp !== undefined && resp !== null && resp.status === "success") {
      toast({
        title: "Perfetto",
        description: "L'abbonamento è stato modificato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      let newPremium = currentUser.premium === 1 ? 0 : 1
      setAllData(allData.map((item) => {
        if (item.id === userid) {
          item.premium = newPremium
        }
        return item
      }
      ))

      setTableContent(tableContent.map((item) => {
        if (item.id === userid) {
          item.premium = newPremium
        }
        return item
      }
      ))

      setLoading(false);
      setIsOpenPro(false)
      setCurrentUser({});
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setIsOpenPro(false)
      setLoading(false);
      setCurrentUser({});
    }

  }

  const onClosePro = () => {
    setIsOpenPro(false)
  }

  const handleChangePRO = async (user) => {

    setCurrentUser(user)
    setIsOpenPro(true)
  }


  /* END - PRO */

  /* BEGIN - Trainings */

  const changeTrainings = async (type) => {
    setLoading(true)
    let userid = currentUser.id

    let resp = await postCall("/changeTrainingsAdmin", {
      user: currentUser,
      value: currentUser.trainings === 1 ? 0 : 1
    })
    if (resp !== undefined && resp !== null && resp.status === "success") {
      toast({
        title: "Perfetto",
        description: "L'utente è stato modificato",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      let newTrainings = currentUser.trainings === 1 ? 0 : 1
      setAllData(allData.map((item) => {
        if (item.id === userid) {
          item.trainings = newTrainings
        }
        return item
      }
      ))

      setTableContent(tableContent.map((item) => {
        if (item.id === userid) {
          item.trainings = newTrainings
        }
        return item
      }
      ))

      setLoading(false);
      setIsOpenTrainings(false)
      setCurrentUser({});
    } else {
      toast({
        title: "Errore",
        description: "Si è verificato un errore: " + resp.error,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setIsOpenTrainings(false)
      setLoading(false);
      setCurrentUser({});
    }

  }

  const onCloseTrainings = () => {
    setIsOpenTrainings(false)
  }

  const handleChangeTrainings = async (user) => {

    setCurrentUser(user)
    setIsOpenTrainings(true)
  }


  /* END - Trainings */

  /* BEGIN - user cover */
  const handleUserCoverChange = async (event) => {

    /* formdata */
    let formData = new FormData();

    //add fields to form
    //formData.append('user', user);
    formData.append('action', 'add')
    formData.append("file", event.target.files[0])

    try {

      const response = await axios.post('/uploadUserCover', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 0,

      });


      if (response.data.status === "success") {
        /* TODO set iamge url here */
        console.log("uploaded_success")

        setCoverPath(response.data.data.coverPath)
      } else {
        /* TODO STOP PROCESS */
        console.log("upload_error")
      }
    } catch (error) {
      console.log(error)
    }

  };

  /* END - user cover */





  const handleSubmitUser = async (event) => {
    event.preventDefault();

    setUpdatedChunks(0)
    if (!user) {
      toast({
        title: "Errore",
        description: "Seleziona un user",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    if (title === "" || title === null || title === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un titolo",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    if (idCategory === null) {
      toast({
        title: "Errore",
        description: "Scegli una categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }


    const currentTimestamp = ((Date.now() / 1000) | 0)

    let chunkSize = 30 * 1024 * 1024; // 5 MB chunk size
    let chunks = [];
    let fileSize = user.size;
    let start = 0;
    let end = chunkSize;

    while (start < fileSize) {
      chunks.push(user.slice(start, end));
      start = end;
      end = start + chunkSize;
    }

    setTotalChunks(chunks.length)
    setLoading(true);
    onCloseCreate()


    /*  console.log(chunks.length)
     console.log(currentTimestamp) */

    let chunksCount = 0;
    for (let i = 0; i < chunks.length; i++) {
      /* await Promise.all(chunks.map(async (chunk, index) => { */
      let chunk = chunks[i]
      let index = i

      console.log("CHUNK-START")

      /* formdata */
      let formData = new FormData();

      //add fields to form
      //formData.append('user', user);
      formData.append('action', 'add')
      formData.append('title', title)
      formData.append('description', description)
      formData.append('long_description', longDescription)
      formData.append('hidden', hidden)
      formData.append('premium', premium)
      formData.append('id_category', idCategory)
      formData.append('chunk', chunk, currentTimestamp + `-chunk-${index}`);
      formData.append('totalChunks', chunks.length);
      formData.append('timestamp', currentTimestamp);
      formData.append('toplist', toplist);
      formData.append('image_path', coverPath);
      formData.append('finalChunk', chunks.length - 1 === index ? "1" : "0");
      formData.append('chunkNumber', index);



      try {

        const response = await axios.post('/uploadChunk', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 0,
        });

        console.log("RESPONSECHUNK", response)

        console.log("ok")
        console.log(response)

        if (response.data.status === "success") {
          chunksCount = chunksCount + 1;
          setUpdatedChunks(chunksCount)
        } else {
          /* TODO STOP PROCESS */
          console.log("upload_error")
          setLoading(false);
          setUser(null);

          //refresh page
          window.location.reload();
          //toast
          toast({
            title: "Errore",
            description: "Si è verificato un errore",
            status: "error",
            duration: 2000,
            isClosable: true,
            position: "top"
          })
        }





      } catch (error) {
        /* TODO stop process */
        console.error(error);
        setLoading(false);
        setUser(null);
        setTimer(null);
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }
    }/* )) */


    try {
      let resp = await postCall("/mergeHls", {
        timestamp: currentTimestamp,
        title: title,
        description: description,
        long_description: longDescription,
        hidden: hidden,
        premium: premium,
        id_category: idCategory,
        toplist: toplist,
        image_path: coverPath

      })
      if (resp !== undefined && resp !== null && resp.status === "success") {
        toast({
          title: "Perfetto",
          description: "I user sono stati aggiornati",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
        fetchUsers()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + resp.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        setLoading(false);
        setUser(null);
        setTimer(null);
      }
    } catch (e) {
      toast({
        title: "Errore",
        description: "Si è verificato un errore",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      setLoading(false);
      setUser(null);
      setTimer(null);
    }




  };

  const fetchCategories = async () => {
    postCall("/fetchCat", {}).then((data) => {

      setAllCategories(data.data)
      setCategories(Array.from(data.data.map((item) => {
        return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
      })));
    });
  }

  const updateUsers = async () => {
    postCall("/updateFromLocalUsers", {}).then((data) => {
      console.log(data);
      if (data.status === "success") {
        toast({
          title: "Perfetto",
          description: "I user sono stati aggiornati",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchUsers()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore: " + data.error,
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const setDefaultCategory = async (id_category) => {

    setDefaultCat(id_category)


    /*  setCategories(Array.from(allCategories.map((item) => {
 
       console.log(item.id_category, id_category)
       if (item.id_category === id_category) {
         return (<option selected key={item.id_category} value={item.id_category}>{item.name}</option>)
       } else {
         return (<option key={item.id_category} value={item.id_category}>{item.name}</option>)
       }
     }))); */
  }


  const fetchUsers = async () => {
    setIsLoading(true)
    postCall("/fetchUsers", {}).then((data) => {


      if (data.status === "success") {

        setAllData(Array.from(data.data.map((item) => {
          return {
            id: item.id_user,
            name: item.name,
            surname: item.surname,
            email: item.email,
            phone: item.phone,
            premium: item.premium,
            trainings: item.trainings,
            created_at: Utils.convertDateToIta(item.created_on, false),
            creation_date: item.created_on
          }
        })));

        setTableContent(Array.from(data.data.map((item) => {
          return {
            id: item.id_user,
            name: item.name,
            surname: item.surname,
            email: item.email,
            phone: item.phone,
            premium: item.premium,
            trainings: item.trainings,
            created_at: Utils.convertDateToIta(item.created_on, false),
            creation_date: item.created_on
          }
        })).slice((page * 10) - 10, (page * 10)));


      } else {
        toast({
          title: "Errore",
          description: "Errore nel recupero user",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    }).finally(() => {
      setIsLoading(false)
    });
  }

  useEffect(() => {

    fetchUsers()
    fetchCategories()

    commonContext.setCurrentPath("Utenti")
    commonContext.setCurrentPage("users")

    return () => {
      // Clean up the interval on component unmount
      clearInterval(timer);
    };

  }, []);


  /* BEGIN - SORTABLE */

  const handleSortSurname = () => {
    setSortedBy("category")
    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => (a.category_name ?? "").localeCompare(b.category_name ?? ""))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => (b.category_name ?? "").localeCompare(a.category_name ?? ""));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {
      /* console.log("item: ", item) */

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        trainings: item.trainings,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date
      }
    })).slice((page * 10) - 10, (page * 10)));
  };


  const handleSortName = () => {
    setSortedBy("category")
    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => (a.category_name ?? "").localeCompare(b.category_name ?? ""))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => (b.category_name ?? "").localeCompare(a.category_name ?? ""));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {
      /* console.log("item: ", item) */

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        trainings: item.trainings,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date
      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.creation_date.localeCompare(b.creation_date))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.creation_date.localeCompare(a.creation_date));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        trainings: item.trainings,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  const handleSortTitle = () => {
    setSortedBy("title")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.title.localeCompare(b.title))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.title.localeCompare(a.title));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        title: item.title,
        description: item.description,
        long_description: item.long_description,
        category_name: item.category_name,
        premium: item.premium,
        trainings: item.trainings,
        hidden: item.hidden,
        id_category: item.id_category,
        toplist: item.toplist,
        image_path: item.image_path,
        created_at: item.created_at,
        creation_date: item.creation_date

      }
    })).slice((page * 10) - 10, (page * 10)));
  };

  /* END - SORTABLE */



  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();

    if (title === "" || title === null || title === undefined) {
      toast({
        title: "Errore",
        description: "Scegli un titolo",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    if (idCategory === null) {
      toast({
        title: "Errore",
        description: "Scegli una categoria",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return;
    }

    postCall("/updateUser", {
      title: title,
      description: description,
      long_description: longDescription,
      hidden: hidden,
      premium: premium,
      id_category: idCategory,
      id_user: idToUpdate,
      toplist: toplist,
      image_path: coverPath
    }).then((data) => {
      if (data.status === "success") {

        fetchUsers()
        setTitle("")
        setDescription("")
        setLongDescription("")
        setHidden(false)
        setPremium(false)
        setIdCategory(null)
        setIdToUpdate(null)

        toast({
          title: "Perfetto",
          description: "User modificato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {
        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, title, description, longDescription, premium, hidden, id_category, category_name, toplist, image_path) => {
    setTitle(title)
    setDescription(description)
    setLongDescription(longDescription)
    setHidden(hidden)
    setPremium(premium)
    setIdCategory(id_category)
    setDefaultCategory(id_category)
    setToplist(toplist)
    setCoverPath(image_path)
    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {
    console.log("openCreate")
    setTitle("")
    setDescription("")
    setLongDescription("")
    setHidden(false)
    setPremium(false)
    setToplist(false)
    setIdCategory(null)
    setDefaultCategory("-1")
    setCoverPath("")
    setIsOpenCreate(true)
  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteUser = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deleteUser", {
      id_user: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "User eliminato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchUsers()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>
      {/* BEGIN - FORM TO EDIT A VIDEO */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Modifica user</ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <form onSubmit={handleSubmitEdit}>

              {/* <button type="submit">Upload</button> */}
              <FormControl id="userName">
                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  <GridItem rowSpan={1} colSpan={1}>
                    <FormLabel
                      mt="25px"
                    >Categoria</FormLabel>
                    <Select
                      defaultValue={defaultCat}
                      onChange={(event) => setIdCategory(event.target.value)}
                      placeholder='Seleziona una categoria'>
                      {categories}
                    </Select>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Titolo</FormLabel>
                    <Input
                      type="text"
                      value={title}
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >





                    <FormLabel mt="15px">Sottotitolo</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="15px">Descrizione</FormLabel>
                    <Textarea
                      mb="20px"
                      type="text"
                      value={longDescription}
                      onChange={(event) => setLongDescription(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >
                    <Flex justifyContent="center" alignItems="center" height="100%">


                      <Checkbox
                        mr="40px"
                        isChecked={premium}
                        onChange={(e) => setPremium(e.target.checked)}
                      >
                        Premium
                      </Checkbox>
                      <Checkbox
                        mr="40px"
                        isChecked={hidden}
                        onChange={(e) => setHidden(e.target.checked)}
                      >
                        Nascosto
                      </Checkbox>

                      <Checkbox
                        isChecked={toplist}
                        onChange={(e) => setToplist(e.target.checked)}
                      >
                        In evidenza
                      </Checkbox>
                    </Flex>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - user cover */}
                    <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="userCover" id="userCover" onChange={handleUserCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    }
                    <Text
                      justifyContent="center"
                      textAlign="center"
                      mt="20px"
                      mb="20px"
                    >(Se non viene selezionata alcuna immagine, verrà utilizzato il primo fotogramma del user)</Text>
                    {/* END - user cover */}
                  </GridItem>

                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica user</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A VIDEO */}

      {/* BEGIN - FORM TO CREATE A NEW VIDEO */}
      <Modal isOpen={isOpenCreate} onClose={onCloseCreate}>
        <ModalOverlay />
        <ModalContent maxW="900px">
          <ModalHeader>Carica un nuovo user</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form>

              {/* <button type="submit">Upload</button> */}
              <FormControl id="categoryName">

                <Grid templateRows="repeat(2, 1fr)" templateColumns="repeat(2, 1fr)" gap={4}>
                  <GridItem rowSpan={1} colSpan={2} >
                    <FormLabel>Seleziona il file</FormLabel>
                    <input type="file" name="user" id="user" onChange={handleFileChange} />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >


                    <FormLabel
                      mt="15px"
                    >Categoria</FormLabel>
                    <Select

                      onChange={(event) => setIdCategory(event.target.value)}
                      placeholder='Seleziona una categoria'>
                      {categories}
                    </Select>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="25px">Titolo</FormLabel>
                    <Input
                      type="text"
                      value={title}
                      onChange={(event) => setTitle(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >
                    <FormLabel mt="15px">Sottotitolo</FormLabel>
                    <Input
                      mb="20px"
                      type="text"
                      value={description}
                      onChange={(event) => setDescription(event.target.value)}
                    />
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={1} >

                    <FormLabel mt="15px">Descrizione</FormLabel>
                    <Textarea
                      mb="20px"
                      type="text"
                      value={longDescription}
                      onChange={(event) => setLongDescription(event.target.value)}
                    />

                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >

                    <Flex justifyContent="center" alignItems="center" height="100%">

                      <Checkbox
                        mr="40px"
                        isChecked={premium}
                        onChange={(e) => setPremium(e.target.checked)}
                      >
                        Premium
                      </Checkbox>
                      <Checkbox
                        mr="40px"
                        isChecked={hidden}
                        onChange={(e) => setHidden(e.target.checked)}
                      >
                        Nascosto
                      </Checkbox>

                      <Checkbox
                        isChecked={toplist}
                        onChange={(e) => setToplist(e.target.checked)}
                      >
                        In evidenza
                      </Checkbox>
                    </Flex>
                  </GridItem>
                  <GridItem rowSpan={1} colSpan={2} >


                    {/* BEGIN - user cover */}
                    <FormLabel mt="35px">Copertina</FormLabel>
                    <input type="file" name="userCover" id="userCover" onChange={handleUserCoverChange} />

                    {coverPath !== "" && coverPath !== null && coverPath !== undefined &&
                      (<Box>
                        <Flex justifyContent="center" alignItems="center" height="100%">
                          <Image maxWidth="200" justifyContent="center" src={utilConstants.serverBaseURL + coverPath.replaceAll("images/", "")} alt='Immagine di copertina' />
                        </Flex>
                      </Box>)
                    }
                    <Text
                      justifyContent="center"
                      textAlign="center"
                      mt="20px"
                      mb="20px"
                    >(Se non viene selezionata alcuna immagine, verrà utilizzato il primo fotogramma del user)</Text>
                    {/* END - user cover */}
                  </GridItem>
                </Grid>
              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter mt="10px">
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitUser}>Carica user</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW VIDEO */}


      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        {/* <Button leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={openCreate}>
          Carica nuovo user
        </Button> */}
        <Box></Box>
        {/* <Button ml="20" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={updateUsers}>
          AGGIORNA
        </Button> */}
        <Input
          borderColor="black"
          w="20%"
          placeholder="Cerca..."
          type="text"
          value={search}
          onChange={(event) => {

            setSearch(event.target.value)

            if (event.target.value === "") {
              setTableContent(allData.slice((page * 10) - 10, (page * 10)))
            }
            else {
              setTableContent(allData.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase()) || item.surname.toLowerCase().includes(event.target.value.toLowerCase()) || item.email.toLowerCase().includes(event.target.value.toLowerCase()) || item.phone.toLowerCase().includes(event.target.value.toLowerCase())))

            }
          }}
        />
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina user
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente il user "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteUser} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}

      {/* BEGIN - CHANGE PRO ALERT */}
      <AlertDialog
        isOpen={isOpenPro}
        onClose={onClosePro}
      >
        <AlertDialogOverlay >
          <AlertDialogContent >
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Modifica abbonamento
            </AlertDialogHeader>

            <AlertDialogBody>
              Sei sicuro di voler {currentUser.premium ? "rimuovere" : "aggiungere"} l'abbonamento PRO a {currentUser.name}?
            </AlertDialogBody>

            <AlertDialogFooter justifyContent="center">
              <Button onClick={onClosePro}>
                Indietro
              </Button>
            </AlertDialogFooter>
            {currentUser.premium === 1 && <AlertDialogFooter justifyContent="center">
              <Button colorScheme='red' onClick={() => changePro("stop")}>
                Procedi
              </Button>
            </AlertDialogFooter>}
            {currentUser.premium === 0 && <AlertDialogFooter justifyContent="center">

              <Button colorScheme='green' onClick={() => changePro("month")} ml={3}>
                Mensile
              </Button>
              <Button colorScheme='blue' onClick={() => changePro("year")} ml={3}>
                Annuale
              </Button>
              <Button colorScheme='yellow' onClick={() => changePro("unlimited")} ml={3}>
                Senza limite
              </Button>

            </AlertDialogFooter>}
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - CHANGE PRO ALERT */}
      {/* BEGIN - CHANGE TRAININGS ALERT */}
      <AlertDialog
        isOpen={isOpenTrainings}
        onClose={onCloseTrainings}
      >
        <AlertDialogOverlay >
          <AlertDialogContent >
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Modifica opzione allenamento
            </AlertDialogHeader>

            <AlertDialogBody>
              Sei sicuro di voler {currentUser.trainings ? "disattivare" : "attivare"} la funzione allenamento per l'utente {currentUser.name}?
            </AlertDialogBody>

            <AlertDialogFooter justifyContent="center">
              <Button onClick={onCloseTrainings}>
                Indietro
              </Button>
              <Button ml={3} colorScheme='green' onClick={() => changeTrainings()}>
                Procedi
              </Button>
            </AlertDialogFooter>

          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - CHANGE TRAININGS ALERT */}

      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        {isLoading && <Spinner size="xl" color="blue" thickness="5px" speed='0.65s' emptyColor='gray.200' />}
        {!isLoading && <Text fontSize="xl" as="b" color="teal">Nessun utente trovato</Text>}
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 &&
        <TableContainer h="100%" >
          <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
            {/* <TableCaption>Elenco delle categorie</TableCaption> */}
            <Thead>
              <Tr>
                <Th w="5%">ID</Th>
                <Th /* _hover={{ cursor: "pointer" }}  onClick={handleSortName} */><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th /* _hover={{ cursor: "pointer" }}  onClick={handleSortSurname} */><Flex align="center">Cognome{sortedBy === "father" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "father" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th>Email</Th>
                <Th>Telefono</Th>
                <Th w="5%">PRO</Th>
                <Th w="10%">Allenamenti</Th>

                <Th /*_hover={{ cursor: "pointer" }}  onClick={handleSortCreated} */ w="12%"><Flex align="center">Creato il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th w="8%"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {tableContent.map((item) => (
                <Tr key={item.id}>
                  <Td>{item.id}</Td>
                  <Td title={item.name} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal">{item.name}</Td>
                  <Td title={item.surname} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal">{item.surname}</Td>
                  <Td title={item.email} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal">{item.email}</Td>
                  <Td title={item.phone} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal">{item.phone}</Td>
                  <Td whiteSpace="normal" onChange={() => handleChangePRO(item)} >{<Switch id={"pro_" + item.id} isChecked={item.premium === 1} />}</Td>
                  <Td whiteSpace="normal" onChange={() => handleChangeTrainings(item)} >{<Switch id={"trainings_" + item.id} isChecked={item.trainings === 1} />}</Td>
                  <Td whiteSpace="normal">{item.created_at}</Td>
                  <Td whiteSpace="normal">

                    <IconButton
                      mr="2"
                      colorScheme='orange'
                      aria-label='Call Segun'
                      size='sm'
                      icon={<MdOutlineSportsGymnastics />}
                      onClick={() => {
                        //go to page calendarPage
                        /* navigate("/useraddsheet", { */
                        navigate("/calendarPage", {
                          state: {
                            user: item
                          }
                        })

                      }}
                    />

                    {/* <IconButton
                      mr="2"
                      colorScheme='orange'
                      aria-label='Call Segun'
                      size='sm'
                      icon={<MdEdit />}
                      onClick={() => {
                        openEdit(item.id, item.name, item.advices === 1, item.trainWithMe === 1, item.in_home === 1, item.id_father)
                      }}
                    /> */}</Td>
                </Tr>
              ))}

            </Tbody>
            <Tfoot>
              <Tr>
                <Th w="5%">ID</Th>
                <Th /* _hover={{ cursor: "pointer" }}  onClick={handleSortName} */><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th /*_hover={{ cursor: "pointer" }}  onClick={handleSortSurname} */><Flex align="center">Cognome{sortedBy === "father" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "father" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th w="8%">Email</Th>
                <Th w="8%">Telefono</Th>
                <Th w="5%">PRO</Th>
                <Th w="10%" >Allenamenti</Th>
                <Th /*_hover={{ cursor: "pointer" }}  onClick={handleSortCreated} */ w="12%"><Flex align="center">Creato il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
                <Th w="8%"></Th>
              </Tr>
            </Tfoot>
          </Table>
        </TableContainer>}


      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 10) - 20, (page * 10) - 10));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {allData.length > 0 ? page : 0} / {Math.ceil(allData.length / 10)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 10)) {
              setTableContent(allData.slice((page * 10), (page * 10) + 10));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}

      {/* BEGIN - LOADING */}
      {loading &&

        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bg="rgba(1, 1, 1, 0.3)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          zIndex={9999}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Center>
            <Spinner
              alignContent="center"
              textAlign="center"
              alignSelf="center"
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              color='blue'
              size='xl'
            />
          </Center>
        </Box>
      }

      {/* END - LOADING */}
    </div>

  );

}

export default UsersList;